var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "u8-index-container",
      attrs: { flex: "dir:top main:justify cross:stretch box:justify" },
    },
    [
      _c(
        "div",
        {
          staticClass: "full",
          staticStyle: { height: "100%" },
          attrs: { flex: "dir:top main:center cross:center" },
        },
        [
          _c("img", {
            staticStyle: { width: "100px" },
            attrs: { src: require("@/assets/images/u8-logo.png") },
          }),
          _c("div", { attrs: { flex: "dir:top main:center cross:center" } }, [
            _c("div", { attrs: { flex: "dir:top main:center cross:center" } }, [
              _c("p", { staticClass: "u8-index__title" }, [
                _vm._v("UG-Quartz 调度中心 " + _vm._s(_vm.$version)),
              ]),
              _c("p", { staticClass: "u8-index__sub-title" }, [
                _vm._v("U8SDK——快速搭建专属你的手游联运平台"),
              ]),
              _c("p", { staticClass: "u8-index__desc" }, [
                _vm._v(
                  "截至2020年12月底，已有超500家企业选择了U8SDK，已上线游戏超过1000款"
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "btn-group" },
              [
                _c(
                  "span",
                  {
                    staticClass: "btn-group__btn",
                    on: {
                      click: function ($event) {
                        return _vm.$open("http://www.u8sdk.com")
                      },
                    },
                  },
                  [_vm._v("官方网站")]
                ),
                _vm._v(" | "),
                _c(
                  "span",
                  {
                    staticClass: "btn-group__btn",
                    on: {
                      click: function ($event) {
                        return _vm.$open("http://www.6xsdk.com/document.html")
                      },
                    },
                  },
                  [_vm._v("在线文档")]
                ),
                _vm._v(" | "),
                _c(
                  "span",
                  {
                    staticClass: "btn-group__btn",
                    on: {
                      click: function ($event) {
                        return _vm.$open("http://www.uustory.com")
                      },
                    },
                  },
                  [_vm._v("技术博客")]
                ),
                _vm._v(" | "),
                _c(
                  "span",
                  {
                    staticClass: "btn-group__btn",
                    on: {
                      click: function ($event) {
                        return _vm.$open(
                          "https://www.bilibili.com/video/BV1QC4y1h7vR/"
                        )
                      },
                    },
                  },
                  [_vm._v("视频教程")]
                ),
                _vm._v(" | "),
                _c("el-popover", { attrs: { width: 172, trigger: "hover" } }, [
                  _c("img", {
                    staticStyle: { width: "172px" },
                    attrs: { src: require("./image/qr@2x.png") },
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "btn-group__btn btn-group__btn--link",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    },
                    [
                      _c("i", { staticClass: "el-icon-s-custom" }),
                      _vm._v(" QQ技术交流群 "),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "margin-top": "0px",
                        "margin-bottom": "0px",
                      },
                    },
                    [
                      _vm._v(
                        " 官方技术大群，成员数1700+， 主要成员是渠道SDK接入相关技术同学，交流渠道SDK接入遇到的各种问题 "
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }